<template>
  <v-container>
    <v-img
      class="white--text align-end"
      height="200px"
      src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
    >
      <v-card-title>Questions for this section: </v-card-title>
    </v-img>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">Description</th>
            <th class="text-left"></th>
            <!-- <th class="text-left"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in questions" :key="item.name">
            <td>{{ item.id }}</td>
            <td>{{ item.description }}</td>
            <td>
              <a :href="'/edit/' + item.id">Update</a>
            </td>
            <!-- <td>
              <a :href="'/answer/' + item.id">Answer</a>
            </td> -->
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <br />
    <br />
    <v-btn color="primary" @click="newQuestion()">New Question</v-btn>
  </v-container>
</template>

<script>
export default {
  name: "AllQuestion",
  props: ["id"],

  methods: {
    async newQuestion() {
      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/question/create/",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify({ section: this.id, type: this.type })
        }
      );

      if (response.ok) {
        var data = await response.json();
        console.log(data);

        this.$router.push({ path: `/edit/${data.id}` }); // -> /user/123
      } else {
        alert(response.status + ": " + response.statusText);
      }

      // var html = await response.text();
      // alert(html);
    }
  },

  data: () => ({
    questions: [],
    type: ""
  }),

  async mounted() {
    var response = await fetch(
      process.env.VUE_APP_API_BASE_URL + "/section/view/" + this.id,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      }
    );

    if (response.ok) {
      var data = await response.json();
      console.log(data);

      this.type = data.type;
      this.questions = data.questions.slice();

      //   this.items = data.questions.length;
      //   for (var i; i < this.items; i++) {
      //     this.answers.push({});
      //   }
      //   this.all();
    } else {
      alert(response.status + ": " + response.statusText);
    }
  }
};
</script>